import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Components from '..';
import Pictures from '../../assets/picture';
import './Cookies.scss';
import getClientsStyle from '../../utils/getClientsStyle';
import {
  COOKIE_SETTINGS_EVENT,
  getConsent,
  setConsent,
} from '../../utils/cookieConsent';

const Cookies = () => {
  const { t } = useTranslation('components');
  const [isVisible, setIsVisible] = useState<boolean>(
    () => getConsent() === null
  );
  const styleForClient = getClientsStyle();

  const decide = (value: 'true' | 'false') => {
    setIsVisible(false);
    setConsent(value);
  };

  useEffect(() => {
    const open = () => setIsVisible(true);
    window.addEventListener(COOKIE_SETTINGS_EVENT, open);
    return () => window.removeEventListener(COOKIE_SETTINGS_EVENT, open);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="berg-components-cookies">
      <img src={Pictures.Cookies} alt="cookies" />
      <p>
        <Trans
          ns="components"
          i18nKey="cookies.text"
          components={{
            a: (
              <Link
                to="/cookies-policy"
                className="berg-components-cookies__link"
                data-client-style={styleForClient}
              />
            ),
          }}
        ></Trans>
      </p>
      <div className="berg-components-cookies__buttons">
        <Components.BergButton
          label={t('cookies.decline')}
          className="berg-button berg-button__primary color"
          data-client-style={styleForClient}
          onClick={() => decide('false')}
        />
        <Components.BergButton
          label={t('cookies.consent')}
          className="berg-button berg-button__primary color"
          data-client-style={styleForClient}
          onClick={() => decide('true')}
        />
      </div>
    </div>
  );
};

export default Cookies;
